module.exports = __webpack_public_path__ + "static/media/Pattern9.ea092e3c.png";